import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { authService } from '../api/services';

export type Lang = 'en' | 'pt';

export function useLanguage() {
  const { i18n } = useTranslation();
  const lang = (i18n.language?.startsWith('pt') ? 'pt' : 'en') as Lang;

  const setLanguage = useCallback(async (next: Lang) => {
    await i18n.changeLanguage(next);
    localStorage.setItem('archimedian_lang', next);
    try {
      await authService.updatePreferences({ language: next });
    } catch {
      // best-effort — localStorage is source of truth until next login
    }
  }, [i18n]);

  return { lang, setLanguage };
}

/** Format a cent amount as a currency string for the current language. */
export function useCurrency() {
  const { i18n } = useTranslation();
  const lang = i18n.language?.startsWith('pt') ? 'pt' : 'en';

  return useCallback((cents: number) => {
    const amount = cents / 100;
    if (lang === 'pt') {
      return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(amount);
    }
    return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(amount);
  }, [lang]);
}
